module.exports = __webpack_public_path__ + "static/media/track.99474927.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Audio/track.ogg
// module id = 522
// module chunks = 0